/**
 * Cart Regions Data — Countries, Governorates & Delivery Rules
 * Single source of truth. Used by: header picker, PDP delivery card, cart, shipping estimator.
 * Edit via Theme Settings → Countries & Delivery
 */
window.__CART_REGIONS = {
  countries: {
    iq: {
      name_ar: "العراق", name_en: "Iraq", flag: "🇮🇶", code: "IQ", currency: "IQD",
      governorates: {
        baghdad:     { name_ar:"بغداد",       name_en:"Baghdad",      zone:"capital", fee:5000, days_min:1, days_max:3, same_day:false,cod:true },
        basra:       { name_ar:"البصرة",      name_en:"Basra",        zone:"south",   fee:5000, days_min:2, days_max:4, same_day:false,cod:true },
        erbil:       { name_ar:"أربيل",       name_en:"Erbil",        zone:"kurdistan",fee:5000, days_min:2, days_max:4, same_day:false,cod:true },
        sulaymaniyah:{ name_ar:"السليمانية",  name_en:"Sulaymaniyah", zone:"kurdistan",fee:5000, days_min:2, days_max:5, same_day:false,cod:true },
        duhok:       { name_ar:"دهوك",        name_en:"Duhok",        zone:"kurdistan",fee:5000, days_min:2, days_max:5, same_day:false,cod:true },
        nineveh:     { name_ar:"نينوى",       name_en:"Nineveh",      zone:"north",   fee:5000, days_min:2, days_max:5, same_day:false,cod:true },
        kirkuk:      { name_ar:"كركوك",       name_en:"Kirkuk",       zone:"north",   fee:5000, days_min:2, days_max:4, same_day:false,cod:true },
        anbar:       { name_ar:"الأنبار",     name_en:"Anbar",        zone:"west",    fee:5000, days_min:3, days_max:5, same_day:false,cod:true },
        najaf:       { name_ar:"النجف",       name_en:"Najaf",        zone:"mid",     fee:5000, days_min:2, days_max:4, same_day:false,cod:true },
        karbala:     { name_ar:"كربلاء",      name_en:"Karbala",      zone:"mid",     fee:5000, days_min:2, days_max:4, same_day:false,cod:true },
        babil:       { name_ar:"بابل",        name_en:"Babil",        zone:"mid",     fee:5000, days_min:2, days_max:3, same_day:false,cod:true },
        diyala:      { name_ar:"ديالى",       name_en:"Diyala",       zone:"mid",     fee:5000, days_min:2, days_max:4, same_day:false,cod:true },
        wasit:       { name_ar:"واسط",        name_en:"Wasit",        zone:"south",   fee:5000, days_min:2, days_max:4, same_day:false,cod:true },
        maysan:      { name_ar:"ميسان",       name_en:"Maysan",       zone:"south",   fee:5000, days_min:2, days_max:5, same_day:false,cod:true },
        dhiqar:      { name_ar:"ذي قار",      name_en:"Dhi Qar",     zone:"south",   fee:5000, days_min:2, days_max:4, same_day:false,cod:true },
        muthanna:    { name_ar:"المثنى",      name_en:"Muthanna",     zone:"south",   fee:5000, days_min:3, days_max:5, same_day:false,cod:true },
        qadisiyyah:  { name_ar:"القادسية",    name_en:"Qadisiyyah",   zone:"mid",     fee:5000, days_min:2, days_max:4, same_day:false,cod:true },
        saladin:     { name_ar:"صلاح الدين",  name_en:"Saladin",      zone:"north",   fee:5000, days_min:2, days_max:4, same_day:false,cod:true }
      }
    }
  },
  // Helper methods
  getCountry: function(code) { return this.countries[code] || null; },
  getGov: function(country, gov) {
    var c = this.countries[country];
    return c ? (c.governorates[gov] || null) : null;
  },
  getName: function(country, gov, lang) {
    var g = this.getGov(country, gov);
    return g ? g['name_' + lang] : '';
  },
  getCountryName: function(code, lang) {
    var c = this.countries[code];
    return c ? c['name_' + lang] : '';
  }
};
